import { Button, Modal } from "djuno-design";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import {
  handleClearWebAppCreationSlice,
  selectWebAppImageCredentialId,
  selectWebAppImageQuery,
  selectWebAppImageValue,
  selectWebAppTagQuery,
} from "../../../../store/web-app/webAppCreateSlice";
import {
  getWebAppAsync,
  handleHideWebAppUpdateImageModal,
  selectWebApp,
  selectWebAppShowUpdateImageModal,
  selectWebAppUpdateLoading,
  updateWebAppAsync,
} from "../../../../store/web-app/webAppSlice";
import { DeployingImageFrom } from "../../create-page-steps/DeployingSourceStep";
import { useCallback, useEffect } from "react";

const WebAppImageEditorModal = () => {
  const webApp = useAppSelector(selectWebApp);

  const isOpen = useAppSelector(selectWebAppShowUpdateImageModal);

  const selectedCredentialId = useAppSelector(selectWebAppImageCredentialId);

  const imageValue = useAppSelector(selectWebAppImageValue);
  const imageQuery = useAppSelector(selectWebAppImageQuery);
  const tagQuery = useAppSelector(selectWebAppTagQuery);

  const updateLoading = useAppSelector(selectWebAppUpdateLoading);

  const dispatch = useAppDispatch();

  // const isNotActive = useMemo(() => {
  //   return webApp?.ServiceStatus !== 2;
  // }, [webApp?.ServiceStatus]);

  const handleUpdateImage = useCallback(() => {
    if (webApp && !updateLoading) {
      dispatch(
        updateWebAppAsync({
          webAppId: webApp.Id.toString(),
          data: {
            ...webApp,
            ImageName: imageValue,
            ImageTag: tagQuery,
            RegistryId: selectedCredentialId,
          },
        })
      ).then((action) => {
        if (action.type === "web-app/update/fulfilled") {
          dispatch(handleHideWebAppUpdateImageModal());
          dispatch(
            getWebAppAsync({
              webAppId: webApp.Id.toString(),
              withoutLoading: true,
            })
          );
        }
      });
    }
  }, [
    dispatch,
    imageValue,
    selectedCredentialId,
    tagQuery,
    updateLoading,
    webApp,
  ]);

  const handleOnClose = useCallback(() => {
    dispatch(handleHideWebAppUpdateImageModal());
    dispatch(handleClearWebAppCreationSlice({}));
  }, [dispatch]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      title="Update Image"
      contentClassName="!max-w-3xl"
      onClose={handleOnClose}
    >
      <DeployingImageFrom />
      {/* {validationResponse && (
        <div className="mt-4 text-sm">
          <WebAppImageValidationMessage {...validationResponse} />
        </div>
      )} */}
      <div className="mt-4 flex justify-end gap-2">
        <Button onClick={handleOnClose} uiType="light">
          Cancel
        </Button>
        <Button
          loading={updateLoading}
          uiType="primary"
          disabled={
            imageValue === "" || imageValue !== imageQuery || tagQuery === ""
          }
          type="submit"
          onClick={handleUpdateImage}
        >
          Save Changes
        </Button>
      </div>
    </Modal>
  );
};

export default WebAppImageEditorModal;
